import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SeamConnectionRepositoryService extends BaseRepositoryService<
  ModelRegistry['seam-connection']
> {
  recordName = 'seam-connection';
  implementMethods = ['findAll', 'createRecord', 'unloadAll'];
}

declare module '@ember/service' {
  interface Registry {
    'repositories/seam-connection': SeamConnectionRepositoryService;
  }
}
